/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex}[_nghost-%COMP%] > *[_ngcontent-%COMP%]{margin:0 4px}[_nghost-%COMP%]   .action-btn[_ngcontent-%COMP%]{width:32px;height:32px;opacity:.42;border-radius:50%;background-color:#d8d8d8;display:flex;justify-content:center;align-items:center}"];
export { styles as styles };
